import {
  FONT_SIZES,
  FONT_WEIGHTS,
  SPACING,
  Text,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import {useRive} from '@rive-app/react-canvas';
import React from 'react';
import bannerBackground from '../assets/banner-bg.png';
import doubleCoinsAnimated from '../assets/double-coins-animated.riv';

export const CoinsMissionBanner: React.FC<{
  className?: string;
  title: string;
  description?: string;
}> = ({className, title, description}) => {
  const {RiveComponent: DoubleCoinsAnimated} = useRive(
    {
      src: doubleCoinsAnimated,
      autoBind: true,
      autoplay: true,
      stateMachines: 'State Machine 1',
    },
    {
      // ensures the canvas matches the device's pixel density
      useDevicePixelRatio: true,
      shouldResizeCanvasToContainer: true,
    },
  );

  return (
    <Wrapper className={className} data-testid="coinsMissionBanner">
      <TextWrapper>
        <Title>{title}</Title>
        {description && <Description>{description}</Description>}
      </TextWrapper>
      <IconsContainer>
        <DoubleCoinsAnimated />
      </IconsContainer>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-block: ${SPACING['Y.Md']};
  padding-inline: ${SPACING['X.Xl2']} ${SPACING['X.Xl3']};

  background-image: url(${bannerBackground});
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  border-radius: 8px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${SPACING['Y.Sm']};
`;

const Title = styled(Text)`
  font-size: ${FONT_SIZES.px12};
  font-weight: ${FONT_WEIGHTS.mediumHeavy};

  ${tabletAndUpLinaria(`
    font-size: ${FONT_SIZES.px14};
  `)}
`;

const Description = styled(Text)`
  font-size: ${FONT_SIZES.px10};
  font-weight: ${FONT_WEIGHTS.mediumBold};

  ${tabletAndUpLinaria(`
    font-size: ${FONT_SIZES.px14};
  `)}
`;

const IconsContainer = styled.div`
  --size: 64px;
  width: var(--size);
  height: var(--size);

  ${tabletAndUpLinaria(`
    --size: 80px;
  `)}
`;
